import React from 'react';
import { oohData } from '../utils/oohData';
import { BrainIcon } from 'lucide-react';
export const OverallAssessment: React.FC = () => {
  const {
    overallAssessment
  } = oohData;
  return <div className="bg-white p-6 rounded-xl shadow-sm border-t-4 border-t-[#1E90FF]" data-id="element-270" data-mp="2cgy0w8vbn017">
      <div className="flex items-center space-x-3 mb-4" data-id="element-271" data-mp="2hfr498gw9ann">
        <div className="p-2 bg-[#1E90FF]/10 text-[#1E90FF] rounded-lg" data-id="element-272" data-mp="2he7nlgrbsxlc">
          <BrainIcon className="w-5 h-5" data-id="element-273" data-mp="22qmk3lqjgwcw" />
        </div>
        <h2 className="text-lg font-medium text-gray-800" data-id="element-274" data-mp="22p1qbyc1thg3">
          Overall Assessment
        </h2>
      </div>
      {/* Slightly larger than standard body copy: this is the editorial verdict */}
      <p className="text-base text-gray-700 leading-relaxed max-w-4xl" data-id="element-275" data-mp="1todcb3mnnh37">
        {overallAssessment}
      </p>
    </div>;
};